(()=>{'use strict';document.documentElement.classList.add('js');
const menu=document.querySelector('#menuDialog'),trigger=document.querySelector('[data-native-menu]');let lastFocus,closing=false;
function close(d,after){if(!d?.open)return;if(d===menu){if(closing)return;closing=true;const dot=d.querySelector('.menu-close-dot').getBoundingClientRect();d.style.setProperty('--origin-x',`${dot.left+dot.width/2}px`);d.style.setProperty('--origin-y',`${dot.top+dot.height/2}px`);d.classList.add('menu-closing');if(after)d.classList.add('menu-navigating');else document.body.classList.remove('menu-active');const instant=matchMedia('(prefers-reduced-motion:reduce)').matches||matchMedia('(max-width:750px)').matches;setTimeout(()=>{if(after){after();return;}d.close();d.classList.remove('menu-open','menu-closing');trigger?.setAttribute('aria-expanded','false');closing=false;lastFocus?.focus();after?.()},instant?0:800)}else{d.close();lastFocus?.focus()}}
trigger?.addEventListener('click',()=>{if(closing||menu.open)return;lastFocus=trigger;document.body.classList.add('menu-active');const r=trigger.getBoundingClientRect();menu.style.setProperty('--origin-x',`${r.left+r.width/2}px`);menu.style.setProperty('--origin-y',`${r.top+r.height/2}px`);menu.showModal();trigger.setAttribute('aria-expanded','true');requestAnimationFrame(()=>requestAnimationFrame(()=>menu.classList.add('menu-open')))});
menu?.querySelectorAll('nav a').forEach(a=>{const label=document.createElement('span');label.className='menu-link-label';label.textContent=a.textContent;a.replaceChildren(label)});
menu?.addEventListener('cancel',e=>{e.preventDefault();close(menu)});menu?.querySelectorAll('a').forEach(a=>a.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0)return;e.preventDefault();close(menu,()=>location.href=a.href)}));
const searchTrigger=document.querySelector('[data-native-search]'),searchForm=document.querySelector('.header-search');
let searchCloseTimer;
function collapseSearch(immediate=false,restoreFocus=false){
 if(!searchForm||searchForm.hidden)return;
 clearTimeout(searchCloseTimer);
 const finish=()=>{searchForm.hidden=true;searchForm.classList.remove('search-collapsing');searchTrigger.hidden=false;if(restoreFocus)searchTrigger.focus()};
 if(immediate||matchMedia('(prefers-reduced-motion:reduce)').matches){finish();return}
 searchForm.classList.add('search-collapsing');searchCloseTimer=setTimeout(finish,220);
}
searchTrigger?.addEventListener('click',e=>{if(innerWidth<=750){try{sessionStorage.setItem('58g-search-return',location.href)}catch{}return}if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();clearTimeout(searchCloseTimer);searchForm.classList.remove('search-collapsing');searchForm.hidden=false;searchTrigger.hidden=true;searchForm.querySelector('input').focus()});
searchForm?.addEventListener('keydown',e=>{if(e.key==='Escape')collapseSearch(false,true)});
searchForm?.addEventListener('focusout',()=>{setTimeout(()=>{if(!searchForm.contains(document.activeElement))collapseSearch()},0)});
document.addEventListener('pointerdown',e=>{if(searchForm&&!searchForm.contains(e.target)&&!searchTrigger.contains(e.target))collapseSearch()});
searchForm?.addEventListener('submit',()=>collapseSearch(true));
addEventListener('pageshow',()=>collapseSearch(true));
addEventListener('resize',()=>{if(innerWidth<=750)collapseSearch(true)});
document.querySelectorAll('[data-mobile-search-close]').forEach(link=>link.addEventListener('click',e=>{let destination=link.href;try{destination=sessionStorage.getItem('58g-search-return')||destination;sessionStorage.removeItem('58g-search-return')}catch{}if(destination!==link.href){e.preventDefault();location.href=destination}}));
document.querySelectorAll('[data-native-close]').forEach(b=>b.addEventListener('click',()=>close(b.closest('dialog'))));
addEventListener('pageshow',e=>{if(e.persisted&&menu){menu.close();menu.classList.remove('menu-open','menu-closing','menu-navigating');document.body.classList.remove('menu-active');trigger?.setAttribute('aria-expanded','false');closing=false;}});
addEventListener('resize',()=>{if(innerWidth>750&&menu?.open)close(menu)});
function init(root=document){
root.querySelectorAll('a,button').forEach(element=>{
 if(element.matches('.artist-reel-test__media-button'))return;
 const fullText=(element.textContent||'').trim();
 if(fullText==='↗'||!fullText.endsWith('↗'))return;
 if(element.classList.contains('fg-arrow-link')){
  if(element.matches('.artist-index-test__row')){
   element.querySelector('.artist-index-test__number')?.classList.remove('fg-arrow-link__label');
   element.querySelector('.artist-index-test__name')?.classList.add('fg-arrow-link__label');
  }
  return;
 }
 let arrow=[...element.children].find(child=>child.getAttribute('aria-hidden')==='true'&&child.textContent.trim()==='↗');
 let label=element.matches('.artist-index-test__row')?element.querySelector('.artist-index-test__name'):arrow?[...element.children].find(child=>child!==arrow&&child.tagName==='SPAN'&&child.getAttribute('aria-hidden')!=='true'):null;
 if(!arrow){
  const walker=document.createTreeWalker(element,NodeFilter.SHOW_TEXT);
  let node,lastArrowNode;
  while(node=walker.nextNode())if(node.nodeValue.includes('↗'))lastArrowNode=node;
  if(!lastArrowNode)return;
  lastArrowNode.nodeValue=lastArrowNode.nodeValue.replace(/\s*↗\s*$/,'');
  label=document.createElement('span');
  label.className='fg-arrow-link__label';
  while(element.firstChild)label.appendChild(element.firstChild);
  arrow=document.createElement('span');
  arrow.className='fg-arrow-link__arrow';
  arrow.setAttribute('aria-hidden','true');
  arrow.textContent='↗';
  element.append(label,arrow);
 }else{
  if(!label){
   label=document.createElement('span');
   label.className='fg-arrow-link__label';
   [...element.childNodes].filter(node=>node!==arrow).forEach(node=>label.appendChild(node));
   element.insertBefore(label,arrow);
  }else label.classList.add('fg-arrow-link__label');
  arrow.classList.add('fg-arrow-link__arrow');
 }
 element.classList.add('fg-arrow-link');
});
const peerHoverMedia=matchMedia('(min-width:751px) and (hover:hover) and (pointer:fine)');
[
 ['.artist-roster','.artist-row'],
 ['.journal-grid','.journal-card','.journal-image'],
 ['.archive-table','.archive-row[data-archive-row]'],
 ['.journal-adjacent','.journal-adjacent__card']
].forEach(([groupSelector,itemSelector,triggerSelector])=>{
 root.querySelectorAll(groupSelector).forEach(group=>{
  if(group.dataset.peerHoverReady==='true')return;
  group.dataset.peerHoverReady='true';
  const items=[...group.querySelectorAll(itemSelector)];
  const clear=()=>{group.classList.remove('is-peer-hovering');items.forEach(item=>item.classList.remove('is-peer-active'))};
  const activate=item=>{if(!peerHoverMedia.matches)return;group.classList.add('is-peer-hovering');items.forEach(peer=>peer.classList.toggle('is-peer-active',peer===item))};
  items.forEach(item=>{
   const trigger=triggerSelector?item.querySelector(triggerSelector):item;
   if(!trigger)return;
   if(group.matches('.journal-grid')){
    item.addEventListener('pointerenter',()=>{if(group.classList.contains('is-list'))activate(item)});
    item.addEventListener('pointerleave',()=>{if(group.classList.contains('is-list'))clear()});
    trigger.addEventListener('pointerenter',()=>{if(!group.classList.contains('is-list'))activate(item)});
    trigger.addEventListener('pointerleave',()=>{if(!group.classList.contains('is-list'))clear()});
    return;
   }
   trigger.addEventListener('pointerenter',()=>{
    activate(item);
   });
   if(triggerSelector)trigger.addEventListener('pointerleave',clear);
  });
  group.addEventListener('pointerleave',clear);
  peerHoverMedia.addEventListener?.('change',event=>{if(!event.matches)clear()});
 });
});
root.querySelectorAll('[data-journal-view]').forEach(button=>{
 const entries=root.querySelector('#'+button.getAttribute('aria-controls'));if(!entries)return;
 const loadMore=entries.parentElement.querySelector('[data-journal-load-more]');
 const hoverPreview=entries.parentElement.querySelector('[data-journal-list-preview]');
 const hoverImage=hoverPreview?.querySelector('img');
 const hoverMedia=matchMedia('(min-width:751px) and (hover:hover) and (pointer:fine)');
 const cards=[...entries.querySelectorAll('[data-journal-entry]')];
 const gridCards=cards.filter(card=>card.dataset.gridEntry==='true');
 const limit=Math.min(15,Math.max(1,Number(entries.dataset.gridLimit)||15));
 let visible=limit;
 gridCards.sort((a,b)=>(b.dataset.journalDate||'0000-00-00').localeCompare(a.dataset.journalDate||'0000-00-00'));
	 cards.forEach((card,index)=>card.dataset.historyIndex=String(cards.length-index).padStart(2,'0'));
	 const formatOf=card=>card.dataset.journalFormat||[...card.classList].find(name=>name.toLowerCase().startsWith('journal-card--')&&!name.includes('pair-'))?.slice('journal-card--'.length).toLowerCase()||'standard';
	 const journalParams=new URLSearchParams(location.search);
	 const portraitSmallTest=journalParams.get('portrait_small_test')==='1';
	 const patternLab=journalParams.get('pattern_lab')==='1';
	 const setTestFormat=(card,format)=>{
	  [...card.classList].filter(name=>name.startsWith('journal-card--')&&!name.includes('pair-')).forEach(name=>card.classList.remove(name));
	  card.dataset.journalFormat=format;
	  card.classList.add(`journal-card--${format}`);
	 };
	 if(portraitSmallTest){
	  gridCards.filter(card=>formatOf(card)==='portrait').slice(0,3).forEach(card=>{
	   setTestFormat(card,'portrait-small');
	  });
	 }
	 if(patternLab){
	  const formats=['portrait-small','wide-standard','wide-standard','portrait-small','portrait-small','portrait-small','portrait-small','standard','standard','full'];
	  gridCards.slice(0,formats.length).forEach((card,index)=>setTestFormat(card,formats[index]));
	  entries.classList.add('journal-grid--pattern-lab');
	 }
	 gridCards.forEach(card=>card.classList.add(`journal-card--${formatOf(card)}`));
	 const isFull=card=>formatOf(card)==='full';
	 const isWide=card=>['wide','wide standard','wide-standard'].includes(formatOf(card));
	 const isWideCompact=card=>['wide compact','wide-compact','wide_compact'].includes(formatOf(card));
	 const isStandard=card=>formatOf(card)==='standard';
	 const isPortrait=card=>formatOf(card)==='portrait';
	 const isPortraitSmall=card=>['portrait small','portrait-small','portrait_small'].includes(formatOf(card));
	 const isPortraitCompact=card=>['portrait compact','portrait-compact','portrait_compact'].includes(formatOf(card));
 const rows=[];
 const makeRow=(type,rowCards,label='')=>{
  const row=document.createElement('div');
  row.className=`journal-layout-row journal-layout-row--${type}`;
  row.dataset.journalLayoutRow=type;
	 if(label){
	  const labelElement=document.createElement('p');
	  labelElement.className='journal-pattern-label micro';
	  labelElement.textContent=label;
	  row.appendChild(labelElement);
	 }
  rowCards.forEach(card=>row.appendChild(card));
  entries.appendChild(row);rows.push(row);
 };
 const normal=[];
 const flushNormal=()=>{
  while(normal.length){
   const count=Math.min(3,normal.length);
   makeRow(count===3?'three':count===2?'two':'one',normal.splice(0,count));
  }
 };
	 if(patternLab&&gridCards.length>=10){
	  makeRow('portrait-wide',gridCards.slice(0,2),'01 / Portrait Small + Wide');
	  makeRow('wide-portrait-small',gridCards.slice(2,4),'02 / Wide + Portrait Small');
	  makeRow('portrait-small',gridCards.slice(4,7),'03 / Three Portrait Small');
	  const compactPortraitCards=gridCards.slice(4,10).map(card=>{
	   const clone=card.cloneNode(true);
	   setTestFormat(clone,'portrait-compact');
	   clone.classList.add('journal-card--pattern-clone');
	   return clone;
	  });
	  makeRow('portrait-compact',compactPortraitCards,'04 / Six Portrait Compact · 3:4');
	  makeRow('two',gridCards.slice(7,9),'05 / Two Standard');
	  makeRow('full',[gridCards[9]],'06 / Full');
	 }else for(let index=0;index<gridCards.length;index+=1){
  const card=gridCards[index];
  if(isFull(card)){flushNormal();makeRow('full',[card]);continue}
	  if(isStandard(card)&&gridCards[index+1]&&isWideCompact(gridCards[index+1])){
	   flushNormal();makeRow('standard-wide-compact',[card,gridCards[index+1]]);index+=1;continue;
	  }
	  if(isWideCompact(card)&&gridCards[index+1]&&isStandard(gridCards[index+1])){
	   flushNormal();makeRow('standard-wide-compact wide-first',[card,gridCards[index+1]]);index+=1;continue;
	  }
	  if(isWideCompact(card)){flushNormal();makeRow('wide-compact',[card]);continue}
	  if(isWide(card)){
   flushNormal();
   const next=gridCards[index+1];
   if(next&&isPortrait(next)){makeRow('pair',[card,next]);index+=1}
   else makeRow('wide',[card]);
	   continue;
	  }
	  if(isPortraitCompact(card)){
	   flushNormal();
	   const portraitCompactCards=[card];
	   while(portraitCompactCards.length<6&&gridCards[index+1]&&isPortraitCompact(gridCards[index+1])){
	    portraitCompactCards.push(gridCards[index+1]);index+=1;
	   }
	   makeRow('portrait-compact',portraitCompactCards);
	   continue;
	  }
	  if(isPortraitSmall(card)){
	   flushNormal();
	   const portraitSmallCards=[card];
	   while(portraitSmallCards.length<3&&gridCards[index+1]&&isPortraitSmall(gridCards[index+1])){
	    portraitSmallCards.push(gridCards[index+1]);index+=1;
	   }
	   makeRow('portrait-small',portraitSmallCards);
	   continue;
	  }
	  normal.push(card);
  const next=gridCards[index+1];
  if(normal.length===3||!next||isFull(next)||isWide(next)||isWideCompact(next))flushNormal();
 }
 flushNormal();
	 const syncPatternPairHeights=()=>{
	  if(!patternLab)return;
	  entries.querySelectorAll('.journal-layout-row--portrait-wide,.journal-layout-row--wide-portrait-small').forEach(row=>{
	   if(innerWidth<=750){row.style.removeProperty('--journal-pattern-stage-height');return}
	   const portrait=row.querySelector('.journal-card--portrait-small .journal-image');
	   if(!portrait)return;
	   row.style.setProperty('--journal-pattern-stage-height',`${portrait.getBoundingClientRect().width*1.25}px`);
	  });
	 };
	 syncPatternPairHeights();
	 if(patternLab&&'ResizeObserver'in window)new ResizeObserver(syncPatternPairHeights).observe(entries);
 const syncRows=()=>rows.forEach(row=>{row.hidden=[...row.querySelectorAll('[data-journal-entry]')].every(card=>card.hidden)});
 const clearLegacyLayout=()=>gridCards.forEach(card=>card.style.removeProperty('grid-row-end'));
	 const apply=list=>{
	  entries.classList.toggle('is-list',list);button.setAttribute('aria-pressed',String(list));const label=button.querySelector('[data-journal-view-label]');if(label)label.textContent=list?(button.dataset.gridLabel||'Grid View'):(button.dataset.listLabel||'List View');
  gridCards.forEach((card,index)=>card.hidden=!list&&index>=visible);
  syncRows();clearLegacyLayout();
  if(loadMore)loadMore.hidden=list||visible>=gridCards.length;
 };
 let saved=false;try{saved=sessionStorage.getItem('58g-journal-view')==='list'}catch{}
 apply(saved);
 button.onclick=()=>{const list=!entries.classList.contains('is-list');apply(list);try{sessionStorage.setItem('58g-journal-view',list?'list':'grid')}catch{}};
 if(loadMore)loadMore.onclick=()=>{visible=Math.min(gridCards.length,visible+limit);apply(false)};
 if(hoverPreview&&hoverImage){
  let activeImage=null,lastPointerX=innerWidth/2,previewFrame=0;
  const hidePreview=()=>{activeImage=null;hoverPreview.classList.remove('is-active')};
  const positionPreview=(imageLink,pointerX=lastPointerX)=>{
   if(!imageLink||!entries.classList.contains('is-list')||!hoverMedia.matches)return hidePreview();
   const card=imageLink.closest('[data-journal-entry]');if(!card)return hidePreview();
   const rect=card.getBoundingClientRect();
   if(rect.bottom<0||rect.top>innerHeight)return hidePreview();
   const width=Math.min(380,Math.max(240,innerWidth*.26)),height=width*1.25,gap=28;
   let x=pointerX+gap;if(x+width>innerWidth-20)x=pointerX-width-gap;
   x=Math.max(20,Math.min(x,innerWidth-width-20));
   const y=Math.max(20,Math.min(rect.top+rect.height/2-height/2,innerHeight-height-20));
   hoverPreview.style.setProperty('--journal-preview-x',`${x}px`);
   hoverPreview.style.setProperty('--journal-preview-y',`${y}px`);
  };
  const movePreview=(e,imageLink)=>{lastPointerX=e.clientX;positionPreview(imageLink,lastPointerX)};
  const syncPreview=()=>{if(!activeImage)return;cancelAnimationFrame(previewFrame);previewFrame=requestAnimationFrame(()=>positionPreview(activeImage))};
  cards.forEach(card=>{
   const imageLink=card.querySelector('.journal-image');if(!imageLink)return;
   imageLink.addEventListener('pointerenter',e=>{
    if(!entries.classList.contains('is-list')||!hoverMedia.matches)return;
    const source=imageLink.querySelector('.journal-image__list img')||imageLink.querySelector('img');if(!source)return;
    activeImage=imageLink;
    hoverImage.src=source.currentSrc||source.src;
    hoverImage.srcset=source.srcset||'';
    hoverImage.sizes='26vw';
    movePreview(e,imageLink);
    hoverPreview.classList.add('is-active');
   });
   imageLink.addEventListener('pointermove',e=>movePreview(e,imageLink));
   imageLink.addEventListener('pointerleave',hidePreview);
  });
  button.addEventListener('click',hidePreview);
  addEventListener('scroll',syncPreview,{passive:true});
  addEventListener('resize',syncPreview,{passive:true});
  addEventListener('blur',hidePreview);
 }
});

root.querySelectorAll('.archive-table').forEach(table=>{
 const preview=table.parentElement.querySelector('[data-archive-hover-preview]');
 const previewImage=preview?.querySelector('img');
 const hoverMedia=matchMedia('(min-width:751px) and (hover:hover) and (pointer:fine)');
 if(!preview||!previewImage)return;
 let activeLink=null,lastPointerX=innerWidth/2,previewFrame=0;
 const hidePreview=()=>{activeLink=null;preview.classList.remove('is-active')};
 const positionPreview=(link,pointerX=lastPointerX)=>{
  if(!link||!hoverMedia.matches)return hidePreview();
  const row=link.closest('[data-archive-row]');if(!row)return hidePreview();
  const rect=row.getBoundingClientRect();
  if(rect.bottom<0||rect.top>innerHeight)return hidePreview();
  const width=Math.min(380,Math.max(240,innerWidth*.26)),height=width*1.25,gap=28;
  let x=pointerX+gap;if(x+width>innerWidth-20)x=pointerX-width-gap;
  x=Math.max(20,Math.min(x,innerWidth-width-20));
  const y=Math.max(20,Math.min(rect.top+rect.height/2-height/2,innerHeight-height-20));
  preview.style.setProperty('--archive-preview-x',`${x}px`);
  preview.style.setProperty('--archive-preview-y',`${y}px`);
 };
 const movePreview=(e,link)=>{lastPointerX=e.clientX;positionPreview(link,lastPointerX)};
 const syncPreview=()=>{if(!activeLink)return;cancelAnimationFrame(previewFrame);previewFrame=requestAnimationFrame(()=>positionPreview(activeLink))};
 table.querySelectorAll('[data-archive-view]').forEach(link=>{
  link.addEventListener('pointerenter',e=>{
   if(!hoverMedia.matches)return;
   const source=link.querySelector('img');if(!source)return;
   activeLink=link;
   previewImage.src=source.currentSrc||source.src;
   previewImage.srcset=source.srcset||'';
   previewImage.sizes='26vw';
   movePreview(e,link);
   preview.classList.add('is-active');
  });
  link.addEventListener('pointermove',e=>movePreview(e,link));
  link.addEventListener('pointerleave',hidePreview);
 });
 addEventListener('scroll',syncPreview,{passive:true});
 addEventListener('resize',syncPreview,{passive:true});
 addEventListener('blur',hidePreview);
});

root.querySelectorAll('[data-journal-share]').forEach(button=>{button.onclick=async()=>{const title=button.dataset.shareTitle||document.title,url=button.dataset.shareUrl||location.href,label=button.querySelector('[data-share-label]');try{if(navigator.share){await navigator.share({title,url});return}await navigator.clipboard.writeText(url);if(label){const original=label.textContent;label.textContent='Link copied';setTimeout(()=>label.textContent=original,1800)}}catch(error){if(error?.name!=='AbortError')location.href=`mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`}}});

root.querySelectorAll('[data-about-gallery]').forEach(gallery=>{
 if(gallery.dataset.galleryReady==='true')return;
 gallery.dataset.galleryReady='true';
 const track=gallery.querySelector('[data-about-gallery-track]');
 const slides=[...gallery.querySelectorAll('[data-about-gallery-slide]')];
 const current=gallery.querySelector('[data-about-gallery-current]');
 if(!track||slides.length<2)return;
 const reducedMotion=matchMedia('(prefers-reduced-motion:reduce)').matches;
 let active=0,frame,autoplayTimer;
 const update=()=>{
  active=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
  if(current)current.textContent=String(active+1);
 };
 const goTo=index=>{
  active=(index+slides.length)%slides.length;
  track.scrollTo({left:active*track.clientWidth,behavior:reducedMotion?'auto':'smooth'});
  if(current)current.textContent=String(active+1);
 };
 const stopAutoplay=()=>{clearTimeout(autoplayTimer)};
 const startAutoplay=(delay=5000)=>{
  stopAutoplay();
  if(reducedMotion||document.hidden)return;
  autoplayTimer=setTimeout(()=>{goTo(active+1);startAutoplay()},delay);
 };
 track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true});
 gallery.querySelectorAll('[data-about-gallery-step]').forEach(button=>{button.onclick=()=>{
  goTo(active+Number(button.dataset.aboutGalleryStep));
  startAutoplay(8000);
 }});
 gallery.addEventListener('pointerenter',stopAutoplay);
 gallery.addEventListener('pointerleave',()=>startAutoplay(3000));
 gallery.addEventListener('focusin',stopAutoplay);
 gallery.addEventListener('focusout',event=>{if(!gallery.contains(event.relatedTarget))startAutoplay(3000)});
 document.addEventListener('visibilitychange',()=>document.hidden?stopAutoplay():startAutoplay(3000));
 update();
 startAutoplay();
});

if(root===document&&document.documentElement.dataset.journalSliderDelegated!=='true'){
 document.documentElement.dataset.journalSliderDelegated='true';
 document.addEventListener('click',event=>{
  const button=event.target.closest('[data-journal-slider-step]');
  if(!button)return;
  const slider=button.closest('[data-journal-slider]');
  const track=slider?.querySelector('[data-journal-slider-track]');
  const slides=slider?[...slider.querySelectorAll('[data-journal-slide]')]:[];
  if(!track||slides.length<2)return;
  const current=slider.querySelector('[data-journal-slider-current]');
  const active=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
  const next=(active+Number(button.dataset.journalSliderStep)+slides.length)%slides.length;
  track.scrollLeft=next*track.clientWidth;
  if(current)current.textContent=String(next+1);
 });
}

root.querySelectorAll('[data-journal-slider]').forEach(slider=>{
 const track=slider.querySelector('[data-journal-slider-track]');
 const slides=[...slider.querySelectorAll('[data-journal-slide]')];
 const current=slider.querySelector('[data-journal-slider-current]');
 if(!track||slides.length<2)return;
 if(slider.dataset.sliderReady==='true')return;
 slider.dataset.sliderReady='true';
 let active=0,frame;
 const update=()=>{active=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));if(current)current.textContent=String(active+1)};
 track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},{passive:true});
 update();
});

root.querySelectorAll('video.article-module__video[autoplay]').forEach(video=>{
 if(video.dataset.journalVideoReady==='true')return;
 video.dataset.journalVideoReady='true';
 video.muted=true;
 if(!('IntersectionObserver' in window))return;
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(entry.isIntersecting){const playback=video.play();if(playback?.catch)playback.catch(()=>{});}
  else video.pause();
 }),{threshold:.12});
 observer.observe(video);
});

root.querySelectorAll('[data-about-news]').forEach(news=>{
 const button=news.querySelector('[data-about-news-toggle]');if(!button)return;
 const items=[...news.querySelectorAll('[data-about-news-item]')],limit=Math.max(1,Number(news.dataset.newsLimit)||5);
 const label=button.querySelector('[data-about-news-label]');
 const apply=expanded=>{items.forEach((item,index)=>item.hidden=!expanded&&index>=limit);button.setAttribute('aria-expanded',String(expanded));if(label)label.textContent=expanded?(button.dataset.lessLabel||'Show fewer news'):(button.dataset.moreLabel||'Show more news')};
 apply(false);button.onclick=()=>apply(button.getAttribute('aria-expanded')!=='true');
});

root.querySelectorAll('[data-product-story-collapse]').forEach(button=>{
 const details=button.closest('.product-story-more');
 const summary=details?.querySelector(':scope > summary');
 if(!details||!summary)return;
 button.onclick=()=>{
  details.open=false;
  summary.focus({preventScroll:true});
  summary.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
 };
});

root.querySelectorAll('.collections-gallery').forEach(gallery=>{const rail=gallery.querySelector('.collections-image-rail');gallery.querySelectorAll('[data-collection-step]').forEach(button=>{button.onclick=()=>{const step=rail.querySelector('a').getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap);rail.scrollBy({left:Number(button.dataset.collectionStep)*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}})});
const photos=[...root.querySelectorAll('[data-native-photo]')];
const showPhoto=b=>{const img=root.querySelector('#native-main-image');if(!img)return;img.removeAttribute('srcset');img.src=b.dataset.nativePhoto;img.alt=b.querySelector('img')?.alt||img.alt;root.querySelector('#native-zoom').href=b.dataset.nativePhoto;photos.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));const rail=b.parentElement;rail.scrollLeft=Math.max(0,b.offsetLeft-rail.offsetLeft-(rail.clientWidth-b.clientWidth)/2)};
photos.forEach(b=>{b.onclick=()=>showPhoto(b)});
root.querySelectorAll('[data-gallery-step]').forEach(b=>{b.onclick=()=>{if(!photos.length)return;const current=Math.max(0,photos.findIndex(x=>x.getAttribute('aria-pressed')==='true'));showPhoto(photos[(current+Number(b.dataset.galleryStep)+photos.length)%photos.length])}});

const select=root.querySelector('#native-variant');if(select){const sync=()=>{const option=select.selectedOptions[0];document.querySelector('#native-price').textContent=option.dataset.price;const available=option.dataset.available==='true';root.querySelectorAll('#waka-product-form button[type=submit]').forEach(b=>{b.disabled=!available;b.textContent=available?'Add to bag':'Sold out'});root.querySelectorAll('[data-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.variant===select.value)));const stock=root.querySelector('[data-product-stock]');if(stock){const tracked=option.dataset.inventoryTracked==='true';const policy=option.dataset.inventoryPolicy;const quantity=Number(option.dataset.inventoryQuantity);stock.textContent=!tracked?(available?'In stock':'Sold out'):(policy==='continue'&&quantity<=0?'Available to order':quantity>0?`${quantity} left in stock`:'Sold out')}const url=new URL(location);url.searchParams.set('variant',select.value);history.replaceState({},'',url)};select.onchange=sync;root.querySelectorAll('[data-variant]').forEach(b=>{b.onclick=()=>{select.value=b.dataset.variant;sync()}});sync()}
const buttons=root.querySelectorAll('[data-filter]'),cards=root.querySelectorAll('.catalogue [data-city]');if(buttons.length){const apply=city=>{let count=0;cards.forEach(c=>{c.hidden=city!=='All Moments'&&c.dataset.city!==city;if(!c.hidden)count++});buttons.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===city)));const status=root.querySelector('.edition-count');if(status)status.textContent=`${count} ${count===1?'release':'releases'}`};buttons.forEach(b=>{b.onclick=()=>{apply(b.dataset.filter);const url=new URL(location);if(b.dataset.filter==='All Moments')url.searchParams.delete('city');else url.searchParams.set('city',b.dataset.filter);history.replaceState({},'',url)}});const chosen=new URL(location).searchParams.get('city');apply([...buttons].some(b=>b.dataset.filter===chosen)?chosen:'All Moments')}
}
const hamburgClock=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Berlin',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
let clockTimer;
function tickClock(){const now=new Date();document.querySelectorAll('[data-hamburg-time]').forEach(el=>{el.textContent=hamburgClock.format(now);el.dateTime=now.toISOString()});clearTimeout(clockTimer);clockTimer=setTimeout(tickClock,60000-(Date.now()%60000)+30)}
tickClock();document.addEventListener('visibilitychange',()=>{if(document.hidden)clearTimeout(clockTimer);else tickClock()});
init();document.addEventListener('shopify:section:load',e=>init(e.target));const current=new URL(location);document.querySelectorAll('.header nav a').forEach(a=>{const u=new URL(a.href);if(u.pathname===current.pathname&&u.searchParams.get('view')===current.searchParams.get('view'))a.setAttribute('aria-current','page')});
})();

// Native mobile footer disclosures; retain open columns on desktop.
(() => {
  const groups = [...document.querySelectorAll('.footer-disclosure')];
  const mobile = window.matchMedia('(max-width: 750px)');
  const sync = () => groups.forEach(group => {
    group.open = !mobile.matches;
    group.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
  });
  groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
    if (!mobile.matches) event.preventDefault();
  }));
  groups.forEach(group => group.addEventListener('toggle', () => {
    if (!mobile.matches || !group.open) return;
    groups.forEach(other => { if (other !== group) other.open = false; });
  }));
  mobile.addEventListener('change', sync);
  sync();
})();
